import { render, staticRenderFns } from "./phone-input.vue?vue&type=template&id=5d1e3155&scoped=true&lang=html&"
import script from "./phone-input.vue?vue&type=script&lang=ts&"
export * from "./phone-input.vue?vue&type=script&lang=ts&"
import style0 from "./phone-input.vue?vue&type=style&index=0&id=5d1e3155&lang=less&scoped=true&"
import style1 from "./phone-input.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1e3155",
  null
  
)

export default component.exports